var render, staticRenderFns
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "@/styles/views/ContentParserStyles/ContentParserStyles.less?vue&type=style&index=0&lang=less&"
import style1 from "@/styles/views/PageView/PageView.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports